/**
 * @module FE-CU19_表示地区設定画面
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import CheckList from '../../../components/checkList/Index.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU22';
export default {
  name: 'NotificationSettingDisplayArea',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    CheckList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知配信設定'), // "通知配信設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU22通知配信設定画面.C0001'), // "対象地区のPUSH通知/Eメール通知の設定を行うことができます。",
      panelTitle: {
        place: ' - ',
        type: '$vuetify.FECU22通知配信設定画面.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [
        {
          id: 1,
          title: '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.利用プラン',
          text: 'オンライン監視プラン',
        },
        {
          id: 2,
          title: '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.お客様番号',
          text: '51-1234567',
        },
        {
          id: 3,
          title: '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.警備先名',
          text: '警備先1',
        },
        {
          id: 4,
          title: '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.地区番号',
          text: '0001',
        },
        {
          id: 5,
          title: '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.地区名',
          text: '地区名1',
        },
      ],
      isDisabledForPush: false,
      isDisabledEmail: false,
      pushTitle: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知内容選択'), //"通知内容選択",
      pushFlag: null,
      pushItems: [
        {
          id: 1,
          name: '$vuetify.FECU22通知配信設定画面.警備操作', //"警備操作",
          flag: false,
          error: '',
        },
        {
          id: 2,
          name: '$vuetify.FECU22通知配信設定画面.侵入', //"侵入",
          flag: false,
          error: '',
        },
        {
          id: 3,
          name: '$vuetify.FECU22通知配信設定画面.火災', //"火災",
          flag: false,
          error: '',
        },
        {
          id: 4,
          name: '$vuetify.FECU22通知配信設定画面.火災復旧', // "火災-復旧",
          flag: false,
          error: '',
        },
        {
          id: 5,
          name: '$vuetify.FECU22通知配信設定画面.ガス', // "ガス",
          flag: false,
          error: '',
        },
        {
          id: 6,
          name: '$vuetify.FECU22通知配信設定画面.ガス復旧', //"ガス-復旧",
          flag: false,
          error: '',
        },
        {
          id: 7,
          name: '$vuetify.FECU22通知配信設定画面.非常緊急', //"非常/救急",
          flag: false,
          error: '',
        },
        {
          id: 8,
          name: '$vuetify.FECU22通知配信設定画面.非常緊急復旧', //"非常/救急-復旧",
          flag: false,
          error: '',
        },
        {
          id: 9,
          name: '$vuetify.FECU22通知配信設定画面.ライフリズム', // "ライフリズム",
          flag: false,
          error: '',
        },
        {
          id: 10,
          name: '$vuetify.FECU22通知配信設定画面.ライフリズム復旧', // "ライフリズム-復旧",
          flag: false,
          error: '',
        },
        {
          id: 11,
          name: '$vuetify.FECU22通知配信設定画面.設備', //"設備",
          flag: false,
          error: '',
        },
        {
          id: 12,
          name: '$vuetify.FECU22通知配信設定画面.設備復旧', //"設備-復旧",
          flag: false,
          error: '',
        },
        {
          id: 13,
          name: '$vuetify.FECU22通知配信設定画面.電池切れ', //"電池切れ",
          flag: false,
          error: '',
        },
        {
          id: 14,
          name: '$vuetify.FECU22通知配信設定画面.電池切れ復旧', //"電池切れ-復旧",
          flag: false,
          error: '',
        },
        {
          id: 15,
          name: '$vuetify.FECU22通知配信設定画面.機器異常', //"機器異常",
          flag: false,
          error: '',
        },
        {
          id: 16,
          name: '$vuetify.FECU22通知配信設定画面.機器異常復旧', // "機器異常-復旧",
          flag: false,
          error: '',
        },
        /* { // #29933 [機能修正管理表No.68] お知らせ削除
          id: 17,
          name: '$vuetify.FECU22通知配信設定画面.お知らせ', //"お知らせ",
          flag: false,
          error: '',
        }, */
      ],
      mailTitle: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知内容選択'), //"通知内容選択",
      mailFlag: null,
      mailItems: [
        {
          id: 1,
          name: '$vuetify.FECU22通知配信設定画面.警備操作', //"警備操作",
          flag: false,
          error: '',
        },
        {
          id: 2,
          name: '$vuetify.FECU22通知配信設定画面.侵入', //"侵入",
          flag: false,
          error: '',
        },
        {
          id: 3,
          name: '$vuetify.FECU22通知配信設定画面.火災', //"火災",
          flag: false,
          error: '',
        },
        {
          id: 4,
          name: '$vuetify.FECU22通知配信設定画面.火災復旧', // "火災-復旧",
          flag: false,
          error: '',
        },
        {
          id: 5,
          name: '$vuetify.FECU22通知配信設定画面.ガス', // "ガス",
          flag: false,
          error: '',
        },
        {
          id: 6,
          name: '$vuetify.FECU22通知配信設定画面.ガス復旧', //"ガス-復旧",
          flag: false,
          error: '',
        },
        {
          id: 7,
          name: '$vuetify.FECU22通知配信設定画面.非常緊急', //"非常/救急",
          flag: false,
          error: '',
        },
        {
          id: 8,
          name: '$vuetify.FECU22通知配信設定画面.非常緊急復旧', //"非常/救急-復旧",
          flag: false,
          error: '',
        },
        {
          id: 9,
          name: '$vuetify.FECU22通知配信設定画面.ライフリズム', // "ライフリズム",
          flag: false,
          error: '',
        },
        {
          id: 10,
          name: '$vuetify.FECU22通知配信設定画面.ライフリズム復旧', // "ライフリズム-復旧",
          flag: false,
          error: '',
        },
        {
          id: 11,
          name: '$vuetify.FECU22通知配信設定画面.設備', //"設備",
          flag: false,
          error: '',
        },
        {
          id: 12,
          name: '$vuetify.FECU22通知配信設定画面.設備復旧', //"設備-復旧",
          flag: false,
          error: '',
        },
        {
          id: 13,
          name: '$vuetify.FECU22通知配信設定画面.電池切れ', //"電池切れ",
          flag: false,
          error: '',
        },
        {
          id: 14,
          name: '$vuetify.FECU22通知配信設定画面.電池切れ復旧', //"電池切れ-復旧",
          flag: false,
          error: '',
        },
        {
          id: 15,
          name: '$vuetify.FECU22通知配信設定画面.機器異常', //"機器異常",
          flag: false,
          error: '',
        },
        {
          id: 16,
          name: '$vuetify.FECU22通知配信設定画面.機器異常復旧', // "機器異常-復旧",
          flag: false,
          error: '',
        },
        /* { // #29933 [機能修正管理表No.68] お知らせ削除
          id: 17,
          name: '$vuetify.FECU22通知配信設定画面.お知らせ', //"お知らせ",
          flag: false,
          error: '',
        }, */
      ],
      isDisabledSettingBtn: true,
      pushError: {
        flag: false,
        message: '$vuetify.メッセージ一覧.FECU22通知配信設定画面.E0002', // "プッシュ通知のチェック項目を１つ以上選択してください。",
      },
      mailError: {
        flag: false,
        message: '$vuetify.メッセージ一覧.FECU22通知配信設定画面.E0003', //"Eメール通知のチェック項目を１つ以上選択してください。",
      },
      firstTimeName: 'firstTimeFlag_22_' + this.$store.state.customerNumber, //初回アクセス時だけ開いておく仕掛け
      modified: '',
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知配信設定'), // "通知配信設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU22通知配信設定画面.C0001'), // "対象地区のPUSH通知/Eメール通知の設定を行うことができます。",
        panelTitle: vm.$vuetify.lang.t(
          '$vuetify.FECU22通知配信設定画面.対象地区詳細領域.対象地区' //ここに引数 ex)"自宅"
        ), //"対象地区 - 自宅",
        pushTitle: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知内容選択'), //"通知内容選択",
        pushItems: [
          {
            id: 1,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.警備操作'), //"警備操作",
            flag: this.pushItems[0].flag, //false
            error: '',
          },
          {
            id: 2,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.侵入'), //"侵入",
            flag: this.pushItems[1].flag, //false
            error: '',
          },
          {
            id: 3,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.火災'), //"火災",
            flag: this.pushItems[2].flag, //false
            error: '',
          },
          {
            id: 4,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.火災復旧'), // "火災-復旧",
            flag: this.pushItems[3].flag, //false
            error: '',
          },
          {
            id: 5,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ガス'), // "ガス",
            flag: this.pushItems[4].flag, //false
            error: '',
          },
          {
            id: 6,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ガス復旧'), //"ガス-復旧",
            flag: this.pushItems[5].flag, //false
            error: '',
          },
          {
            id: 7,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.非常緊急'), //"非常/救急",
            flag: this.pushItems[6].flag, //false
            error: '',
          },
          {
            id: 8,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.非常緊急復旧'), //"非常/救急-復旧",
            flag: this.pushItems[7].flag, //false
            error: '',
          },
          {
            id: 9,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ライフリズム'), // "ライフリズム",
            flag: this.pushItems[8].flag, //false
            error: '',
          },
          {
            id: 10,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ライフリズム復旧'), // "ライフリズム-復旧",
            flag: this.pushItems[9].flag, //false
            error: '',
          },
          {
            id: 11,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.設備'), //"設備",
            flag: this.pushItems[10].flag, //false
            error: '',
          },
          {
            id: 12,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.設備復旧'), //"設備-復旧",
            flag: this.pushItems[11].flag, //false
            error: '',
          },
          {
            id: 13,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.電池切れ'), //"電池切れ",
            flag: this.pushItems[12].flag, //false
            error: '',
          },
          {
            id: 14,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.電池切れ復旧'), //"電池切れ-復旧",
            flag: this.pushItems[13].flag, //false
            error: '',
          },
          {
            id: 15,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.機器異常'), //"機器異常",
            flag: this.pushItems[14].flag, //false
            error: '',
          },
          {
            id: 16,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.機器異常復旧'), // "機器異常-復旧",
            flag: this.pushItems[15].flag, //false
            error: '',
          },
          /* { // #29933 [機能修正管理表No.68] お知らせ削除
            id: 17,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.お知らせ'), //"お知らせ",
            flag: this.pushItems[16].flag, //false
            error: '',
          }, */
        ],
        mailTitle: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.通知内容選択'), //"通知内容選択",
        mailItems: [
          {
            id: 1,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.警備操作'), //"警備操作",
            flag: this.mailItems[0].flag, //false
            error: '',
          },
          {
            id: 2,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.侵入'), //"侵入",
            flag: this.mailItems[1].flag, //false
            error: '',
          },
          {
            id: 3,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.火災'), //"火災",
            flag: this.mailItems[2].flag, //false
            error: '',
          },
          {
            id: 4,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.火災復旧'), // "火災-復旧",
            flag: this.mailItems[3].flag, //false
            error: '',
          },
          {
            id: 5,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ガス'), // "ガス",
            flag: this.mailItems[4].flag, //false
            error: '',
          },
          {
            id: 6,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ガス復旧'), //"ガス-復旧",
            flag: this.mailItems[5].flag, //false
            error: '',
          },
          {
            id: 7,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.非常緊急'), //"非常/救急",
            flag: this.mailItems[6].flag, //false
            error: '',
          },
          {
            id: 8,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.非常緊急復旧'), //"非常/救急-復旧",
            flag: this.mailItems[7].flag, //false
            error: '',
          },
          {
            id: 9,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ライフリズム'), // "ライフリズム",
            flag: this.mailItems[8].flag, //false
            error: '',
          },
          {
            id: 10,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.ライフリズム復旧'), // "ライフリズム-復旧",
            flag: this.mailItems[9].flag, //false
            error: '',
          },
          {
            id: 11,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.設備'), //"設備",
            flag: this.mailItems[10].flag, //false
            error: '',
          },
          {
            id: 12,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.設備復旧'), //"設備-復旧",
            flag: this.mailItems[11].flag, //false
            error: '',
          },
          {
            id: 13,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.電池切れ'), //"電池切れ",
            flag: this.mailItems[12].flag, //false
            error: '',
          },
          {
            id: 14,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.電池切れ復旧'), //"電池切れ-復旧",
            flag: this.mailItems[13].flag, //false
            error: '',
          },
          {
            id: 15,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.機器異常'), //"機器異常",
            flag: this.mailItems[14].flag, //false
            error: '',
          },
          {
            id: 16,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.機器異常復旧'), // "機器異常-復旧",
            flag: this.mailItems[15].flag, //false
            error: '',
          },
          /* { // #29933 [機能修正管理表No.68] お知らせ削除
            id: 17,
            name: vm.$vuetify.lang.t('$vuetify.FECU22通知配信設定画面.お知らせ'), //"お知らせ",
            flag: this.mailItems[16].flag, //false
            error: '',
          }, */
        ],
        pushError: {
          flag: false,
          message: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU22通知配信設定画面.E0002'), // "プッシュ通知のチェック項目を１つ以上選択してください。",
        },
        mailError: {
          flag: false,
          message: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU22通知配信設定画面.E0003'), //"Eメール通知のチェック項目を１つ以上選択してください。",
        },
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 全て選択押下処理(PUSH通知)
     */
    onPushAllClick: function () {
      this.pushItems.forEach(function (item) {
        item.flag = true;
      });
      this.checkValid();
    },
    /**
     * クリアボタン押下処理(PUSH通知)
     */
    onPushClearClick: function () {
      this.pushItems.forEach(function (item) {
        item.flag = false;
      });
      this.checkValid();
    },
    /**
     * 全て選択押下処理(Eメール通知)
     */
    onMailAllClick: function () {
      this.mailItems.forEach(function (item) {
        item.flag = true;
      });
      this.checkValid();
    },
    /**
     * クリアボタン押下処理(Eメール通知)
     */
    onMailClearClick: function () {
      this.mailItems.forEach(function (item) {
        item.flag = false;
      });
      this.checkValid();
    },
    /**
     * バリデーションチェック処理
     */
    checkValid: function () {
      if (this.pushFlag === true && this.mailFlag === true) {
        // PUSH通知・Eメール通知の両方が「通知する」の場合、両方のチェック状態確認
        this.checkPushCheckbox();
        this.checkMailCheckbox();
      } else if (this.pushFlag === true && this.mailFlag === false) {
        // PUSH通知が「通知する」、Eメール通知が「通知しない」の場合、PUSH通知のチェック状態確認
        this.checkPushCheckbox();
        this.mailError.flag = false;
      } else if (this.pushFlag === false && this.mailFlag === true) {
        // PUSH通知が「通知しない」、Eメール通知が「通知する」の場合、Eメール通知のチェック状態確認
        this.checkMailCheckbox();
        this.pushError.flag = false;
      } else {
        // PUSH通知・Eメール通知の両方が「通知しない」の場合、チェック状態確認なし
        this.pushError.flag = false;
        this.mailError.flag = false;
      }

      //「通知しない」場合チェックを外す
      if (!this.pushFlag) {
        this.pushItems.forEach(function (item) {
          item.flag = false;
        });
      }
      if (!this.mailFlag) {
        this.mailItems.forEach(function (item) {
          item.flag = false;
        });
      }

      // 設定ボタンの活性判定
      this.isDisabledSettingBtn =
        this.pushError.flag === false && this.mailError.flag === false ? false : true;
    },
    /**
     * チェックボックスチェック処理(PUSH通知)
     */
    checkPushCheckbox: function () {
      // PUSH通知のチェックボックス状態確認
      for (let i = 0; i < this.pushItems.length; i++) {
        if (this.pushItems[i].flag === true) {
          this.pushError.flag = false;
          break;
        }
        this.pushError.flag = true;
      }
    },
    /**
     * チェックボックスチェック処理(Eメール通知)
     */
    checkMailCheckbox: function () {
      // Eメール通知のチェックボックス状態確認
      for (let i = 0; i < this.mailItems.length; i++) {
        if (this.mailItems[i].flag === true) {
          this.mailError.flag = false;
          break;
        }
        this.mailError.flag = true;
      }
    },
    /**
     * 初期表示(APP_CU2201)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU2201: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       displayDistrictFacilityName: "自宅",
            //       usagePlanId: 0,
            //       customerNumber: "51-1234567",
            //       districtSplitName: "地区名1234",
            //       districtSplitNumber: "0001",
            //     },
            //     pushNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isSecurityOperateNotification: true,
            //       isIntrusionNotification: true,
            //       isFireNotification: true,
            //       isFireRecoveryNotification: true,
            //       isGasNotification: true,
            //       isGasRecoveryNotification: true,
            //       isEmergencyNotification: true,
            //       isEmergencyRecoveryNotification: true,
            //       isLifeRhythmfireNotification: true,
            //       isLifeRhythmfireRecoveryNotification: true,
            //       isEquipmentNotification: true,
            //       isEquipmentRecoveryNotification: true,
            //       isLowBatteryNotification: true,
            //       isLowBatteryRecoveryNotification: true,
            //       isEquipmentErrorNotification: true,
            //       isEquipmentErrorRecoveryNotification: true,
            //       isNewsNotification: true,
            //     },
            //     mailNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isSecurityOperateNotification: true,
            //       isIntrusionNotification: true,
            //       isFireNotification: true,
            //       isFireRecoveryNotification: true,
            //       isGasNotification: true,
            //       isGasRecoveryNotification: true,
            //       isEmergencyNotification: true,
            //       isEmergencyRecoveryNotification: true,
            //       isLifeRhythmfireNotification: true,
            //       isLifeRhythmfireRecoveryNotification: true,
            //       isEquipmentNotification: true,
            //       isEquipmentRecoveryNotification: true,
            //       isLowBatteryNotification: true,
            //       isLowBatteryRecoveryNotification: true,
            //       isEquipmentErrorNotification: true,
            //       isEquipmentErrorRecoveryNotification: true,
            //       isNewsNotification: true,
            //     },
            //     modified: "2022-05-16 12:00:00",
            //   },
            // };

            // 対象地区情報をマッピング
            const displayDistrictInfo = apiData.contentsInfo.displayDistrictInfo;
            switch (displayDistrictInfo.usagePlan) {
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.オンライン監視プラン';
                this.displayAreaList[0].isVuetifyKey = true;
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.依頼かけつけプラン';
                this.displayAreaList[0].isVuetifyKey = true;
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.セルフ監視プラン';
                this.displayAreaList[0].isVuetifyKey = true;
                break;
              default:
                break;
            }
            this.displayAreaList[1].text = displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text = displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU22通知配信設定画面.メイン地区'
                : displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text = displayDistrictInfo.districtSplitName;
            this.panelTitle.place = ' - ' + displayDistrictInfo.displayDistrictNickname;

            // push通知をマッピング
            const pushInfo = apiData.contentsInfo.pushNotificationDeliveryInfo;
            this.pushFlag = pushInfo.isNotification == false ? false : true;
            this.pushItems[0].flag = pushInfo.isSecurityOperateNotification;
            this.pushItems[1].flag = pushInfo.isIntrusionNotification;
            this.pushItems[2].flag = pushInfo.isFireNotification;
            this.pushItems[3].flag = pushInfo.isFireRecoveryNotification;
            this.pushItems[4].flag = pushInfo.isGasNotification;
            this.pushItems[5].flag = pushInfo.isGasRecoveryNotification;
            this.pushItems[6].flag = pushInfo.isEmergencyNotification;
            this.pushItems[7].flag = pushInfo.isEmergencyRecoveryNotification;
            this.pushItems[8].flag = pushInfo.isLifeRhythmfireNotification;
            this.pushItems[9].flag = pushInfo.isLifeRhythmfireRecoveryNotification;
            this.pushItems[10].flag = pushInfo.isEquipmentNotification;
            this.pushItems[11].flag = pushInfo.isEquipmentRecoveryNotification;
            this.pushItems[12].flag = pushInfo.isLowBatteryNotification;
            this.pushItems[13].flag = pushInfo.isLowBatteryRecoveryNotification;
            this.pushItems[14].flag = pushInfo.isEquipmentErrorNotification;
            this.pushItems[15].flag = pushInfo.isEquipmentErrorRecoveryNotification;
            //this.pushItems[16].flag = pushInfo.isNewsNotification; // #29933 [機能修正管理表No.68] お知らせ削除

            // mail通知をマッピング
            const mailInfo = apiData.contentsInfo.mailNotificationDeliveryInfo;
            this.mailFlag = mailInfo.isNotification == false ? false : true;
            this.mailItems[0].flag = mailInfo.isSecurityOperateNotification;
            this.mailItems[1].flag = mailInfo.isIntrusionNotification;
            this.mailItems[2].flag = mailInfo.isFireNotification;
            this.mailItems[3].flag = mailInfo.isFireRecoveryNotification;
            this.mailItems[4].flag = mailInfo.isGasNotification;
            this.mailItems[5].flag = mailInfo.isGasRecoveryNotification;
            this.mailItems[6].flag = mailInfo.isEmergencyNotification;
            this.mailItems[7].flag = mailInfo.isEmergencyRecoveryNotification;
            this.mailItems[8].flag = mailInfo.isLifeRhythmfireNotification;
            this.mailItems[9].flag = mailInfo.isLifeRhythmfireRecoveryNotification;
            this.mailItems[10].flag = mailInfo.isEquipmentNotification;
            this.mailItems[11].flag = mailInfo.isEquipmentRecoveryNotification;
            this.mailItems[12].flag = mailInfo.isLowBatteryNotification;
            this.mailItems[13].flag = mailInfo.isLowBatteryRecoveryNotification;
            this.mailItems[14].flag = mailInfo.isEquipmentErrorNotification;
            this.mailItems[15].flag = mailInfo.isEquipmentErrorRecoveryNotification;
            //this.mailItems[16].flag = mailInfo.isNewsNotification; // #29933 [機能修正管理表No.68] お知らせ削除

            this.modified = apiData.contentsInfo.modified;

            this.checkValid();
          },
          (error /* eslint-disable-line */) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 通知配信設定更新（表示地区）(APP_CU2202)
     * @returns レスポンス
     */
    APP_CU2202: function () {
      this.$_setLoading(true);

      let method = 'post';
      let param = '/api/displayDistrictNotificationDeliverySetting/update';
      // let param = "post"; // 検証用

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        pushNotificationDeliveryInfo: {
          isNotification: this.pushFlag == false ? false : true,
          isSecurityOperateNotification: this.pushItems[0].flag,
          isIntrusionNotification: this.pushItems[1].flag,
          isFireNotification: this.pushItems[2].flag,
          isFireRecoveryNotification: this.pushItems[3].flag,
          isGasNotification: this.pushItems[4].flag,
          isGasRecoveryNotification: this.pushItems[5].flag,
          isEmergencyNotification: this.pushItems[6].flag,
          isEmergencyRecoveryNotification: this.pushItems[7].flag,
          isLifeRhythmfireNotification: this.pushItems[8].flag,
          isLifeRhythmfireRecoveryNotification: this.pushItems[9].flag,
          isEquipmentNotification: this.pushItems[10].flag,
          isEquipmentRecoveryNotification: this.pushItems[11].flag,
          isLowBatteryNotification: this.pushItems[12].flag,
          isLowBatteryRecoveryNotification: this.pushItems[13].flag,
          isEquipmentErrorNotification: this.pushItems[14].flag,
          isEquipmentErrorRecoveryNotification: this.pushItems[15].flag,
          //isNewsNotification: this.pushItems[16].flag, // #29933 [機能修正管理表No.68] お知らせ削除
        },
        mailNotificationDeliveryInfo: {
          isNotification: this.mailFlag == false ? false : true,
          isSecurityOperateNotification: this.mailItems[0].flag,
          isIntrusionNotification: this.mailItems[1].flag,
          isFireNotification: this.mailItems[2].flag,
          isFireRecoveryNotification: this.mailItems[3].flag,
          isGasNotification: this.mailItems[4].flag,
          isGasRecoveryNotification: this.mailItems[5].flag,
          isEmergencyNotification: this.mailItems[6].flag,
          isEmergencyRecoveryNotification: this.mailItems[7].flag,
          isLifeRhythmfireNotification: this.mailItems[8].flag,
          isLifeRhythmfireRecoveryNotification: this.mailItems[9].flag,
          isEquipmentNotification: this.mailItems[10].flag,
          isEquipmentRecoveryNotification: this.mailItems[11].flag,
          isLowBatteryNotification: this.mailItems[12].flag,
          isLowBatteryRecoveryNotification: this.mailItems[13].flag,
          isEquipmentErrorNotification: this.mailItems[14].flag,
          isEquipmentErrorRecoveryNotification: this.mailItems[15].flag,
          //isNewsNotification: this.mailItems[16].flag, // #29933 [機能修正管理表No.68] お知らせ削除
        },
        modified: this.modified,
      };

      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // localStorageに初回表示が完了したことを保存
            if (localStorage.getItem(this.firstTimeName) === null) {
              localStorage.setItem(this.firstTimeName, true);
            }

            // レスポンスステータスが200の場合、更新完了ダイアログを表示
            this.$informationDialog(
              '$vuetify.FECU22通知配信設定画面.設定が完了しました',
              false,
              true
            );
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              // レスポンスステータスが400の場合、エラーダイアログ表示
              this.$errorDialog('$vuetify.メッセージ一覧.FECU22通知配信設定画面.E0001');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 登録確認ダイアログ表示処理
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU22通知配信設定画面.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "確認",
        // "設定された内容で登録します。\n\rよろしいでしょうか。",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.APP_CU2202();
      }
    },
    /**
     * 横幅変更処理
     * @param {*} width 横幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * 戻る処理
     */
    back() {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let method = 'post';
    let param = '/api/displayDistrictNotificationDeliverySetting/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    // APP_CU2201
    await this.APP_CU2201(param, queries, method);

    //警備ユニットと通信しない為、データが揃ってから表示
    this.isShowPage = true;
  },
};
